/**
 * @fileoverview GET handler for the "/engagement/report_builder_2/:app_group_id/segment_identities" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2AppGroupIdSegmentIdentities } from "./constants";
import type { GetEngagementReportBuilder2AppGroupIdSegmentIdentitiesResult } from "./types";
import { isGetEngagementReportBuilder2AppGroupIdSegmentIdentitiesResult } from "./validators";

export const getEngagementReportBuilder2AppGroupIdSegmentIdentities = reactQueryFetcherAdapter(
  engagementReportBuilder2AppGroupIdSegmentIdentities,
  (
    signal: AbortSignal,
    appGroupId: string,
    segmentIds: string[]
  ): Promise<GetEngagementReportBuilder2AppGroupIdSegmentIdentitiesResult> => {
    return fetch(
      `/engagement/report_builder_2/${appGroupId}/segment_identities`,
      "GET",
      { segment_ids: segmentIds },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetEngagementReportBuilder2AppGroupIdSegmentIdentitiesResult
);
